// Cloud/Pi auth token source: the current Firebase user's ID token.
// Vite alias-swaps this module for the embedded variant so apiFetch
// itself stays target-agnostic.
import { getAuthInstance } from '@/lib/firebase';

export async function getAuthToken(): Promise<string | null> {
  const auth = getAuthInstance();
  // Wait until Firebase has finished restoring / processing auth state before
  // reading currentUser. Without this, calls that fire during initial load or
  // the SSO-redirect settle see currentUser === null, send no token, and get a
  // 401 ("Missing Bearer token") even though login is completing.
  await auth.authStateReady();
  const user = auth.currentUser;
  if (!user) return null;
  return user.getIdToken();
}
